module.exports = __webpack_public_path__ + "img/MX-B024035B-AS.14267449.png";